import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';

export const newApplicationsBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'applications',
    url: '/applications/outgoing'
  },
  {
    label: 'outgoing',
    url: '/applications/outgoing'
  },
  {
    label: 'new_application',
    active: true
  }
];

export type NewApplicationsData = {
  orders: string;
  recipient: string;
  currency: string;
  date_create: string;
  sender: string;
  sender_pid: number;
  currency_pid: number;
  guid: string;
  gupid: number;
};
